module.exports = __webpack_public_path__ + "img/logo.735f2ca3.jpg";